module.exports = __webpack_public_path__ + "static/media/HTML.d3d90390.png";